if (customElements.get('wishlist-button') === undefined) {
  class WishlistButton extends HTMLElement {
    constructor() {
      super();

      if (typeof(Storage) === 'undefined') {
        this.setAttribute('hidden', true);
        return;
      }

      this.addText = this.querySelector('[data-wishlist-add-text]');
      this.removeText = this.querySelector('[data-wishlist-remove-text]');

      this.setWishlistState();
      this.addEventListener('click', this.toggleItem.bind(this), false);
      this.hidden = false;
    }

    toggleItem() {
      this.getWishList();

      if (this.dataset.productId in this.wishlist) {
        delete this.wishlist[this.dataset.productId];

        this.classList.remove('added');
        this.addText.hidden = false;
        this.removeText.hidden = true;

      } else {
        this.wishlist[this.dataset.productId] = {
          title: this.dataset.productTitle, handle: this.dataset.productHandle
        };

        this.classList.add('added');
        this.addText.hidden = true;
        this.removeText.hidden = false;
      }

      localStorage.setItem('wishlist', JSON.stringify(this.wishlist));
    }

    getWishList() {
      this.wishlist = localStorage.getItem('wishlist');
      this.wishlist = this.wishlist ? JSON.parse(this.wishlist) : {};
    }

    setWishlistState() {
      this.getWishList();
      if (this.dataset.productId in this.wishlist) {
        this.classList.add('added');
        this.addText.hidden = true;
        this.removeText.hidden = false;
      }
    }
  }

  customElements.define('wishlist-button', WishlistButton);
}
